<div class="create-knowledge-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ 'Content.CreateNewContent' | translate }}</h2>
      <p class="subtitle">{{ 'Content.CreateNewContentSubtitle' | translate }}</p>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" [disabled]="buttonLock" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="form-content" [class.with-toc]="showTOC">
    <!-- Basic Info -->
    <div class="input-group">
      <label>{{ 'Global.Title' | translate }}</label>
      <input type="text" [(ngModel)]="courseName" [placeholder]="'Content.EnterTitle' | translate" class="st-input" [disabled]="buttonLock" />
    </div>

    <div class="input-group">
      <label>{{ 'Global.DescriptionContent' | translate }}</label>
      <textarea rows="4" [(ngModel)]="courseDescription" [placeholder]="'Content.EnterDescriptionExample' | translate" class="st-input" [disabled]="buttonLock"></textarea>
    </div>

    <!-- TOC Editor -->
    @if (showTOC) {
      <div class="toc-editor">
        <div class="toc-header">
          <h3 class="toc-title">Table des matières générée</h3>
          <span class="count">{{ toc.sections.length }} sections</span>
        </div>

        <!-- Sections List (Sortable) -->
        <div class="sections-list" cdkDropList (cdkDropListDropped)="dropSection($event)">
          @for (section of toc.sections; track section; let i = $index) {
            <div class="section-item" cdkDrag>
              <!-- Section Header -->
              <div class="section-row">
                <div class="drag-handle" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </div>
                <button mat-icon-button class="toggle-btn" (click)="toggleSection(section)">
                  <mat-icon>{{ section.isExpanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
                </button>
                <input [(ngModel)]="section.title" class="title-input section-title" />

                <div class="actions">
                  <button mat-icon-button color="warn" (click)="deleteSection(i)" class="delete-btn">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Nested Lectures List (Sortable) -->
              @if (section.isExpanded) {
                <div
                  class="lectures-list"
                  cdkDropList
                  [cdkDropListData]="section.lectures"
                  (cdkDropListDropped)="dropLecture($event)"
                  [id]="'section-' + i"
                  [cdkDropListConnectedTo]="connectedDropLists"
                >
                  @for (lecture of section.lectures; track lecture; let j = $index) {
                    <div class="lecture-item" cdkDrag>
                      <mat-icon class="lecture-icon">article</mat-icon>
                      <input [(ngModel)]="lecture.title" class="title-input lecture-title" />
                      <button mat-icon-button class="delete-lecture-btn" (click)="deleteLectureFromSection(i, j)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  }
                  <button class="add-lecture-btn" (click)="addLectureToSection(i)">
                    <mat-icon>add</mat-icon>
                    {{ 'Content.AddLecture' | translate }}
                  </button>
                </div>
              }
            </div>
          }
        </div>

        <button class="add-section-btn" (click)="addSection()">
          <mat-icon>add_circle_outline</mat-icon>
          {{ 'Content.AddSection' | translate }}
        </button>

        <!-- Standalone Lectures -->
        @if (toc.standaloneLectures.length > 0) {
          <div class="standalone-list-container">
            <h4>{{ 'Content.StandaloneLectures' | translate }}</h4>
            <div
              class="lectures-list standalone"
              cdkDropList
              [cdkDropListData]="toc.standaloneLectures"
              (cdkDropListDropped)="dropLecture($event)"
              id="standalone-lectures"
              [cdkDropListConnectedTo]="connectedDropLists"
            >
              @for (lecture of toc.standaloneLectures; track lecture; let k = $index) {
                <div class="lecture-item" cdkDrag>
                  <mat-icon class="lecture-icon">article</mat-icon>
                  <input [(ngModel)]="lecture.title" class="title-input lecture-title" />
                  <button mat-icon-button class="delete-lecture-btn" (click)="deleteStandaloneLecture(k)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
              <button class="add-lecture-btn" (click)="addStandaloneLecture()">
                <mat-icon>add</mat-icon>
                {{ 'Content.AddLecture' | translate }}
              </button>
            </div>
          </div>
        }

        <!-- Refinement Instructions -->
        <div class="input-group">
          <label>{{ 'Content.AdditionalInstructions' | translate }}</label>
          <textarea rows="3" [(ngModel)]="instructions" [placeholder]="'Content.AdditionalInstructionsPlaceholder' | translate" class="st-input"></textarea>

          <button matButton="tonal" color="primary" class="regenerate-btn" (click)="regenerateTOC()" [disabled]="isGenerating">
            <div class="btn-content">
              @if (isGenerating) {
                <mat-spinner diameter="18"></mat-spinner>
              }
              {{ 'Content.RegenerateWithInstructions' | translate }}
            </div>
          </button>
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <!-- AI Generation Trigger -->
    @if (!showTOC) {
      <div class="ai-trigger-section">
        <button mat-flat-button class="generate-btn" (click)="generateTOC()" [disabled]="isGenerating || !courseName">
          <div class="btn-content">
            @if (isGenerating) {
              <mat-spinner diameter="18"></mat-spinner>
            } @else {
              <mat-icon>auto_awesome</mat-icon>
            }
            <span>{{ 'Content.GenerateTOCWithAI' | translate }}</span>
          </div>
        </button>
      </div>
    } @else {
      <div class="dummy-placeholder"></div>
    }

    <div class="section-right">
      <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
      <button mat-flat-button color="primary" (click)="createCourse()" [disabled]="loading || !courseName" class="submit-btn" [class.loading]="loading">
        @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          {{ 'Content.CreateKnowledge' | translate }}
        }
      </button>
    </div>
  </mat-dialog-actions>
</div>
